import { render, staticRenderFns } from "./CondominiumOverview.vue?vue&type=template&id=1b619fd8&scoped=true"
import script from "./CondominiumOverview.vue?vue&type=script&lang=js"
export * from "./CondominiumOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b619fd8",
  null
  
)

export default component.exports